import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import Swal from "sweetalert";
import { setHeading } from "../../../accounts/account.actions";
import { addPayment, clearShopLedger } from "../CreateIssuance/Issuance.action";
import { getShopByArea } from "../AddShop/Shop.action";
import { getArea } from "../AddArea/Area.action";
import moment from "moment";
import { getUserRes } from "../../AddUser/user.actions";
import { searchAccountLedgerTable } from "../OrderBooking/OrderBooking.action";
import { AddReturnApi } from "./Return.action";



const AddReturnWithPayment = (props) => {
    const [areaName, setAreaName] = useState("");
    const [areaId, setAreaId] = useState();
    const [shopName, setShopName] = useState("");
    const [shopId, setShopId] = useState();
    const [payment, setPayment] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [discountReason, setDiscountReason] = useState("");
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [bookerId, setBookerId] = useState("");
    const [bookerName, setBookerName] = useState("");
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };
    function uploadPayment() {
        props.AddReturnApi({
            areaId: { areaId, areaName },
            bookerId: { _id: bookerId, userName: bookerName },
            shopId: { shopId, shopName },
            paidAmount: payment,
            date,
            discount,
            discountReason,
            closingBalance: props.shopLedgerData?.closingBalance || 0,
        },
            handleVisible,
            handleDangerVisible
        );
        setAreaId("");
        setAreaName("");
        setShopId("");
        setShopName("");
        setBookerId("");
        setBookerName("");
        setPayment(0);
        setDiscount(0);
        setDiscountReason("");
        props.clearShopLedger(); // clear shop balance from Redux
    }

    const handleChangeArea = (selectedOption) => {
        setAreaId(selectedOption.value);
        setAreaName(selectedOption.label);
        props.getShopByArea(selectedOption.value);
    };
    const AreaListData = !isEmpty(props.areaDataList) && props.areaDataList.map((x) => {
        let data = { value: x._id, label: x.areaName };
        return data;
    });


    const handleChangeShop = (selectedOption) => {
        setShopId(selectedOption.value);
        setShopName(selectedOption.label);
        props.searchAccountLedgerTable({ levelFourId: selectedOption.value, })
    };
    const ShopListData = !isEmpty(props.shopsByAreaList) && props.shopsByAreaList.map((x) => {
        let data = { value: x._id, label: x.shopName };
        return data;
    });


    const filterdUserList = !isEmpty(props.userList) && props.userList.filter((e) => e.role == "salesmen");
    const BookerList = !isEmpty(filterdUserList) && filterdUserList.map((x) => {
        let data = { value: x._id, label: x.userName };
        return data;
    });
    const handleChangeBooker = (selectedOption) => {
        setBookerId(selectedOption.value);
        setBookerName(selectedOption.label);
    };


    useEffect(() => {
        props.setHeading("Add Payment");
        props.getArea();
        props.getUser();
    }, []);

    return (
        <>
            {props.isFetchingUser && props.isAddingPayment && props.isFetchingAreaData ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="grow"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <div className="main">
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label> <b>Select Area *</b></Form.Label>
                                    <Select
                                        isDisabled={isEmpty(props.areaDataList)}
                                        value={areaId ? { value: areaId, label: areaName } : null}
                                        placeholder="Select Area..."
                                        onChange={handleChangeArea}
                                        options={AreaListData}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label> <b>Select Shop *</b></Form.Label>
                                    <Select
                                        isDisabled={isEmpty(props.shopsByAreaList) || isEmpty(areaName)}
                                        value={shopId ? { value: shopId, label: shopName } : null}
                                        placeholder="Select Shop..."
                                        onChange={handleChangeShop}
                                        options={ShopListData}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Shop Balance </b> </Form.Label>
                                    <Form.Control
                                        value={isEmpty(props.shopLedgerData) ? '' : `${props.shopLedgerData?.closingBalance} - ${props.shopLedgerData?.closingBalanceSign}`}
                                        disabled
                                        type="text"
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Date </b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                    ></Form.Control>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3 mt-3">
                                    <Form.Label><b>Select SalesMen *</b></Form.Label>
                                    <Select
                                        value={bookerId ? { value: bookerId, label: bookerName } : null}
                                        placeholder="Select SalesMen"
                                        onChange={handleChangeBooker}
                                        options={BookerList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3 mt-3">
                                    <Form.Label> <b>Amount *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        onChange={(e) => { setPayment(e.target.value); }}
                                        value={payment}
                                        min={0}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col>
                                <Form.Group className="mb-3 mt-3">
                                    <Form.Label> <b>Discount </b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        onChange={(e) => { setDiscount(e.target.value); }}
                                        value={discount}
                                        min={0}
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3 mt-3">
                                    <Form.Label> <b>Discount Reason </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={(e) => { setDiscountReason(e.target.value); }}
                                        value={discountReason}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {isEmpty(areaId) || isEmpty(payment) || isEmpty(shopId) || isEmpty(bookerId) ? (
                            <Button disabled> Save </Button>
                        ) : (
                            <Button onClick={() => { uploadPayment() }}> Save  </Button>
                        )}
                    </div>
                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        AddReturnApi: (data, handleVisible, handleDangerVisible) => dispatch(AddReturnApi(data, handleVisible, handleDangerVisible)),
        getArea: () => dispatch(getArea()),
        getShopByArea: (id) => dispatch(getShopByArea(id)),
        getUser: () => dispatch(getUserRes()),
        searchAccountLedgerTable: (data) => dispatch(searchAccountLedgerTable(data)),
        clearShopLedger: () => dispatch(clearShopLedger()),
    };
};
const mapStateToProps = (state, ownProps) => ({
    shopsByAreaList: state.ShopReducer.shopsByAreaList,
    isFetchingShopsByArea: state.ShopReducer.isFetchingShopsByArea,
    areaDataList: state.AreaReducer.areaDataList,
    isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
    productDataList: state.ProductReducer.productDataList,
    isFetchingProduct: state.ProductReducer.isFetchingProduct,
    issuanceStatusList: state.CreateIssuanceReducer.issuanceStatusList,
    isFetchingStatusIssuanceData: state.CreateIssuanceReducer.isFetchingStatusIssuanceData,
    generateIssuancePDFList: state.CreateIssuanceReducer.generateIssuancePDFList,
    isFetchingGenerateIssuancePDF: state.CreateIssuanceReducer.isFetchingGenerateIssuancePDF,
    paymentData: state.CreateIssuanceReducer.paymentData,
    isAddingPayment: state.CreateIssuanceReducer.isAddingPayment,
    isFetchingUser: state.UserReducer.isFetchingUser,
    userList: state.UserReducer.userList,
    shopLedgerData: state.OrderBookingReducer.shopLedgerData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReturnWithPayment);